<style lang="scss">
  @import '../resources/scss/moreInfoLinkBtn.scss';
</style>

<script lang="ts">
  import ArrowRight from './svgs/ArrowRight.svelte'

  export let link: string
  export let name: string
  export let btnClass: string
</script>

<a
  href={link}
  target="_blank"
  class="d-flex topic-item {btnClass ?? ''} justify-content-between align-items-center"
>
  <span class="font-btn">{name}</span>
  <ArrowRight />
</a>
